// src/components/AIChatToggle.jsx
// Floating action button (FAB) to open the AI chat panel.
// Bottom-right corner, hidden when panel is open.

import React from 'react';
import { Sparkles } from 'lucide-react';
import { useAgentChatContext } from '../context/AgentChatContext';

export default function AIChatToggle() {
  const { isOpen, openChat, isStreaming } = useAgentChatContext();

  if (isOpen) return null;

  return (
    <button
      onClick={openChat}
      className={`fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full
        bg-gradient-to-br from-indigo-500 to-purple-600
        ring-2 ring-white/10 dark:ring-white/5
        flex items-center justify-center
        shadow-lg shadow-indigo-500/30
        hover:shadow-2xl hover:shadow-indigo-500/40 hover:scale-105
        focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-indigo-500/40
        transition-all duration-200
        ${isStreaming ? 'animate-pulse' : ''}`}
      title="Open AI Assistant"
      aria-label="Open AI Assistant"
    >
      <Sparkles size={22} className="text-white drop-shadow-sm" />
    </button>
  );
}
